import { Text } from 'tamagui'
import { useTranslation } from 'react-i18next'
import { IPricing } from './hooks'

// Peças de preço compartilhadas pelo hero, aside e rodapé — cada seção compõe
// com seus tamanhos e cores (o rodapé inverte destaque e cherry, como o tema).

export function AnchorPrice({
  value,
  fontSize,
}: {
  value: string
  fontSize: number
}) {
  return (
    <Text
      color="$text-primary"
      fontSize={fontSize}
      fontFamily="$mulishBold"
      fontWeight="700"
      textDecorationLine="line-through"
    >
      {value}
    </Text>
  )
}

export function CurrentPrice({
  price,
  period,
  color,
  fontSize,
  periodFontSize,
}: {
  price: string | null
  period?: string | null
  color: string
  fontSize: number
  periodFontSize: number
}) {
  const { t } = useTranslation('ProductPage')

  return (
    <Text
      color={color}
      fontSize={fontSize}
      fontFamily="$mulishBold"
      fontWeight="700"
    >
      {price}
      {period ? (
        <Text
          color="$text-primary"
          fontSize={periodFontSize}
          fontFamily="$mulishRegular"
        >
          {' '}
          {t(`price.period.${period}`)}
        </Text>
      ) : null}
    </Text>
  )
}

export function InstallmentLine({
  installment,
  installmentKey,
  color,
  fontSize,
}: {
  installment: NonNullable<IPricing['installment']>
  installmentKey: string
  color: string
  fontSize: number
}) {
  const { t } = useTranslation('ProductPage')

  return (
    <Text color={color} fontSize={fontSize} fontFamily="$mulishRegular">
      {t(installmentKey, {
        installments: installment.count,
        amount: installment.amount,
      })}
    </Text>
  )
}
